import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance70 = () => {
  return <IndividualTable matchType={"PRE"} gender="M" event="70" subTitle="Puta" data={sampleData} topRankCount="16" />;
};
export default Distance70;
